<template>
	<div class="five-image-panel" v-if="images && images.length > 0">
		<div class="columns">
			<div class="column">
				<div class="image primary" :style="imageStyles(images[0])"></div>
			</div>
			<div class="column" v-if="images.length > 1">
				<div class="columns">
					<div class="column">
						<div class="image" :style="imageStyles(images[1])"></div>
					</div>
					<div class="column" v-if="images.length > 2">
						<div class="image" :style="imageStyles(images[2])"></div>
					</div>
				</div>
				<div class="columns" v-if="images.length > 3">
					<div class="column">
						<div class="image" :style="imageStyles(images[3])"></div>
					</div>
					<div class="column"  v-if="images.length > 4">
						<div class="image" :style="imageStyles(images[4])"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "FiveImagePanel",
	props: {
        images: {
            type: Array,
            default: () => []
        },
        backgroundColor: {
        	type: String,
        	default: "transparent"
        },
        position: {
        	type: String,
        	default: "cover"
        }
	},
	
	methods: {
		imageStyles(image) {
			let styles = {
				background: `url("${image}") ` + this.backgroundColor,
				backgroundPosition: "center center"
			};
			
			if(this.position === "cover") {
				styles.backgroundSize = "cover";
			} else if(this.position === "contain") {
				styles.backgroundSize = "contain";
				styles.backgroundRepeat = "no-repeat";
			}
			
			return styles;
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
